import * as React from 'react'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Typography from '@mui/material/Typography'
import { Card, CardContent } from '@mui/material'
import Language from '../../components/Language/Language'
import image from '../../images/graph.png'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { CommonTextBox, ConfirmPassword, Password } from '../../components/TextBox'
import { useTranslation } from 'react-i18next'
import { useCheckVerifyCodeMutation, useUpdatePasswordMutation } from '../../store/api/authApi'
import { toast } from 'react-toastify'
import { useEffect } from 'react'
import Progress from './Progress'
import { validateForm, validateFormPass } from '../../validation/validation'

export default function ResetPassword() {
  const { t } = useTranslation('login')
  const { t: l } = useTranslation('loginAndRegister')

  const navigate = useNavigate()
  const handleLogin = () => {
    navigate('/login')
  }
  const [code, setCode] = useState('')
  const [disable, setDisable] = useState(true)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [checkVerifyCode, { data, error, isLoading }] = useCheckVerifyCodeMutation()
  const [updatePassword, { data: dataUpdatedPassword, error: errorUpdatedPassword }] = useUpdatePasswordMutation()

  useEffect(() => {
    if (data?.statusCode === 200) {
      setDisable(false)
      toast.success('The code has been verified successfully.')
    } else if (error?.data?.statusCode === 422) {
      toast.error("We can't found this verify code!")
    }
  }, [data, error])

  useEffect(() => {
    if (dataUpdatedPassword?.statusCode === 200) {
      toast.success('Password updated successfully.')
      navigate('/login')
    } else if (errorUpdatedPassword?.data?.statusCode === 422) {
      toast.error('Password update unsuccessful!')
    }
  }, [dataUpdatedPassword, errorUpdatedPassword])

  useEffect(() => {
    if (code?.length === 6) {
      checkVerifyCode({
        verificationCode: code,
      })
    }
  }, [code])

  const handleUpdate = () => {
    const errors = validateFormPass(password, confirmPassword)

    if (Object.keys(errors).length === 0) {
      updatePassword({
        resetPasswordCode: code,
        password,
        confirmPassword,
      })
    } 
    else {
      Object.values(errors).forEach((error) => {
        toast.error(error)
        return
      })
    }
  }

  const contentForget = (
    <>
      <Box sx={{ display: 'flex', aligntItems: 'center', justifyContent: 'space-between', mt: 2, mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar sx={{ m: 1, backgroundColor: '#2196f3' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {/* {t("forgotPassword")} */}
            Write Verification Code
          </Typography>
        </Box>
        <Box>
          <Language />
        </Box>
      </Box>

      <Grid container alignItems="center" ml={6} maxWidth={300}>
        <Grid item xs={8}>
          <CommonTextBox label={'Enter Verification Code'} value={code} setValue={setCode} type="tel" maxLength={6}/>
        </Grid>
        <Grid item xs={2} ml={1}>
          <Progress statusCode={data?.statusCode} loading={isLoading} />
        </Grid>
      </Grid>

      <Grid container display="flex" justifyContent="space-between" alignItems="center" m={5} maxWidth={400}>
        <Grid item xs={12} m={1}>
          <Password password={password} setPassword={setPassword} disabled={disable} />
        </Grid>
        <Grid item xs={12} m={1}>
          <ConfirmPassword
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            disabled={disable}
          />
        </Grid>
      </Grid>

      <Grid container display="flex" alignContent="space-around" justifyContent="center" mt={2}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }} mt={4}>
          <Button type="submit" variant="contained" s sx={{ width: 250 }} onClick={() => handleUpdate()}>
            Update Password
          </Button>
        </Grid>
      </Grid>
    </>
  )

  const contentText = (
    <>
      <img
        alt="Under development"
        src={image}
        style={{
          position: 'absolute',
          zIndex: -1,
          top: -250,
          left: -110,
          opacity: '10%',
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150 }}>
        <Typography variant="h4" sx={{ color: 'white' }}>
          Sola Soft
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150 }}>
        <Typography variant="subtitle1" sx={{ color: 'white', textAlign: 'center' }}>
          {l('slogan')}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', height: 100 }}>
        <Typography variant="subtitle1" sx={{ color: 'white', textAlign: 'center' }}></Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', height: 60 }}>
        <Button variant="outlined" sx={{ color: 'white' }} onClick={handleLogin}>
          {l('loginName')}
        </Button>
      </Box>
    </>
  )

  return (
    <div className="animation-bg">
      <Grid container width={{ xs: 400, sm: 400, md: 800 }}>
        <Grid item sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} md={4} lg={4} xl={4}>
          <Card sx={{ zIndex: 2, position: 'relative', backgroundColor: '#2196f3', height: 500 }}>
            <CardContent>{contentText}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
          <Card sx={{ zIndex: 2, position: 'relative', height: 500 }}>
            <CardContent>{contentForget}</CardContent>
          </Card>
        </Grid>
      </Grid>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  )
}
